import * as TypeGraphQL from "type-graphql";
export var SignalPriorityQueueScalarFieldEnum;
(function (SignalPriorityQueueScalarFieldEnum) {
    SignalPriorityQueueScalarFieldEnum["id"] = "id";
    SignalPriorityQueueScalarFieldEnum["timestamp"] = "timestamp";
    SignalPriorityQueueScalarFieldEnum["signalId"] = "signalId";
    SignalPriorityQueueScalarFieldEnum["symbol"] = "symbol";
    SignalPriorityQueueScalarFieldEnum["signalType"] = "signalType";
    SignalPriorityQueueScalarFieldEnum["generatorSource"] = "generatorSource";
    SignalPriorityQueueScalarFieldEnum["priorityScore"] = "priorityScore";
    SignalPriorityQueueScalarFieldEnum["generatorWinRate"] = "generatorWinRate";
    SignalPriorityQueueScalarFieldEnum["generatorSharpe"] = "generatorSharpe";
    SignalPriorityQueueScalarFieldEnum["priorityTier"] = "priorityTier";
    SignalPriorityQueueScalarFieldEnum["scoreComponents"] = "scoreComponents";
    SignalPriorityQueueScalarFieldEnum["queuePosition"] = "queuePosition";
    SignalPriorityQueueScalarFieldEnum["status"] = "status";
    SignalPriorityQueueScalarFieldEnum["queuedAt"] = "queuedAt";
    SignalPriorityQueueScalarFieldEnum["processingStartedAt"] = "processingStartedAt";
    SignalPriorityQueueScalarFieldEnum["processingCompletedAt"] = "processingCompletedAt";
    SignalPriorityQueueScalarFieldEnum["timeInQueueMs"] = "timeInQueueMs";
    SignalPriorityQueueScalarFieldEnum["signalConfidence"] = "signalConfidence";
    SignalPriorityQueueScalarFieldEnum["signalData"] = "signalData";
    SignalPriorityQueueScalarFieldEnum["updatedAt"] = "updatedAt";
})(SignalPriorityQueueScalarFieldEnum || (SignalPriorityQueueScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(SignalPriorityQueueScalarFieldEnum, {
    name: "SignalPriorityQueueScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=SignalPriorityQueueScalarFieldEnum.js.map